<template>
  <div class="form-container">
    <div v-if="loading" class="loading-overlay">
      <b-spinner
        label="Loading..."
        variant="primary"
        class="spinner"
      ></b-spinner>
    </div>
    <h2>{{ title }}</h2>
    <div v-if="contains(14)">
      <div class="form-group-custom">
        <label> What type of organization do you work for? </label>
        <HiloSelect
          :theme="'grey'"
          v-model="form.organizationType"
          :options="[]"
          :placeholder="'Choose one...'"
          :customStyle="{
            height: '50px',
            width: '100%',
            padding: '10px',
          }"
        />
      </div>
    </div>
    <!--    Part of V2 when we can add requests to add flight schools -->
    <!--    <div v-if="contains(1, 4, 14, 7, 10)">-->
    <!--      <div class="form-group-custom">-->
    <!--        <label for="is-connected">-->
    <!--          <span v-if="contains(1, 7, 10)">-->
    <!--            Are you already connected with a flight school?-->
    <!--          </span>-->
    <!--          <span v-if="contains(4)">-->
    <!--            Are you already affiliated with a flight school?-->
    <!--          </span>-->
    <!--          <span v-if="contains(14)">-->
    <!--            Are you affiliated with a flight school or employer?-->
    <!--          </span>-->
    <!--        </label>-->
    <!--        <HiloSelect-->
    <!--          :theme="'grey'"-->
    <!--          v-model="form.isConnectedToAFlightSchool"-->
    <!--          :options="[-->
    <!--            { id: true, name: 'Yes' },-->
    <!--            { id: false, name: 'No' },-->
    <!--          ]"-->
    <!--          :placeholder="'Choose one...'"-->
    <!--          :customStyle="{-->
    <!--            height: '50px',-->
    <!--            width: '100%',-->
    <!--            padding: '10px',-->
    <!--          }"-->
    <!--        />-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    <div v-if="form.isConnectedToAFlightSchool" class="gap">-->
    <div class="gap">
      <div v-if="contains(1, 4, 14, 7, 10)" class="gap">
        <div class="form-group-custom">
          <label for="flight-school">Select flight school</label>
          <div class="search-container">
            <HiloSelect
              :theme="'grey'"
              v-model="form.flightSchoolId"
              :options="flightSchoolsList"
              :placeholder="'Choose one...'"
              :customStyle="{
                height: '50px',
                width: '100%',
                padding: '10px',
              }"
            />
          </div>
        </div>

        <!--      V2 -->
        <!--      <div class="form-group-custom">-->
        <!--        <div class="search-action">-->
        <!--          <span>Don't see your flight school on the list?</span>-->
        <!--          <button type="button" @click="showAddModal">Add it here</button>-->
        <!--        </div>-->
        <!--      </div>-->
      </div>

      <div class="form-group-custom">
        <div class="flex-row" :style="$global.dynamicCols(2)">
          <div class="form-group-custom">
            <label for="point-of-contact">Flight school point of contact</label>
            <input
              type="text"
              v-model="form.pointOfContact"
              id="point-of-contact"
              placeholder="Name..."
              readonly
            />
          </div>
          <div class="form-group-custom">
            <label for="phone">Phone</label>
            <input
              type="text"
              v-model="form.phone"
              id="phone"
              placeholder="Phone number..."
              readonly
            />
          </div>
        </div>
      </div>

      <div class="form-group-custom sm-gap">
        <div>
          <label>Flight school address</label>
          <input
            type="text"
            v-model="form.street"
            id="street"
            placeholder="Street address..."
            readonly
          />
        </div>
        <div class="flex-row sm-gap" :style="$global.dynamicCols(2)">
          <div class="form-group-custom">
            <input
              type="text"
              v-model="form.aptOrSuite"
              id="apt-or-suite"
              placeholder="Apt. or Suite..."
              readonly
            />
          </div>
          <div class="form-group-custom">
            <input
              type="text"
              v-model="form.city"
              id="city"
              placeholder="City..."
              readonly
            />
          </div>
        </div>

        <div class="flex-row sm-gap" :style="$global.dynamicCols(3)">
          <div class="form-group-custom">
            <input
              type="text"
              v-model="form.state"
              id="state"
              placeholder="State..."
              readonly
            />
          </div>
          <div class="form-group-custom">
            <input
              type="text"
              v-model="form.zip"
              id="zip"
              placeholder="Zip..."
              readonly
            />
          </div>
          <div class="form-group-custom">
            <input
              type="text"
              v-model="form.country"
              id="country"
              placeholder="Country..."
              readonly
            />
          </div>
        </div>
      </div>
    </div>

    <div v-if="contains(7, 18, 10)" class="gap">
      <div class="form-group-custom" v-if="contains(18)">
        <label for="flight-school-url">What is your Flight school’s URL?</label>
        <input
          type="text"
          v-model="form.flightSchoolUrl"
          id="flight-school-url"
          placeholder="Type your answer..."
        />
      </div>

      <div class="form-group-custom">
        <label>What FAA guidelines does your flight school adhere to?</label>
        <HiloSelect
          :theme="'grey'"
          v-model="form.faaGuidelines"
          :options="[]"
          :placeholder="'Choose one...'"
          :customStyle="{
            height: '50px',
            width: '100%',
            padding: '10px',
          }"
        />
      </div>

      <div v-if="contains(18)" class="gap">
        <div class="form-group-custom">
          <label
            >How many years has your flight school been in operation?</label
          >
          <HiloSelect
            :theme="'grey'"
            v-model="form.yearsOperated"
            :options="[]"
            :placeholder="'Choose one...'"
            :customStyle="{
              height: '50px',
              width: '100%',
              padding: '10px',
            }"
          />
        </div>

        <div class="form-group-custom">
          <label for="enrolled-students"
            >How many students are currently enrolled?</label
          >
          <input
            type="text"
            v-model="form.enrolledStudents"
            id="enrolled-students"
            placeholder="Type your answer..."
          />
        </div>

        <div class="form-group-custom">
          <label>What programs does your school offer?</label>
          <HiloSelect
            :theme="'grey'"
            v-model="form.programOffer"
            :options="[]"
            :placeholder="'Select all that apply...'"
            :customStyle="{
              height: '50px',
              width: '100%',
              padding: '10px',
            }"
          />
        </div>

        <div class="form-group-custom">
          <label for="program-cost">How much do your programs Cost?</label>
          <input
            type="text"
            v-model="form.programCost"
            id="program-cost"
            placeholder="Type your answer..."
          />
        </div>

        <div class="form-group-custom">
          <label for="aircraft-in-fleet"
            >How many Aircraft are in your fleet?</label
          >
          <input
            type="text"
            v-model="form.aircraftInFleet"
            id="aircraft-in-fleet"
            placeholder="Type your answer..."
          />
        </div>

        <div class="form-group-custom">
          <label for="aircraft-type"
            >What type of aircraft do you operate?</label
          >
          <input
            type="text"
            v-model="form.aircraftType"
            id="aircraft-type"
            placeholder="Type your answer..."
          />
        </div>

        <div class="form-group-custom">
          <label>What facilities do you have at your flight school?</label>
          <HiloSelect
            :theme="'grey'"
            v-model="form.facilities"
            :options="[]"
            :placeholder="'Select all that apply...'"
            :customStyle="{
              height: '50px',
              width: '100%',
              padding: '10px',
            }"
          />
        </div>

        <div class="form-group-custom">
          <div class="upload-action">
            <span>Upload photos here.</span>
            <label for="upload-photos" class="upload-btn">
              Upload
              <input
                type="file"
                id="upload-photos"
                @change="(event) => handleFileUpload(event, 'photos')"
                class="hidden-file-input"
              />
            </label>
          </div>
        </div>

        <div class="form-group-custom">
          <label for="employee-count"
            >How many employees do you have on staff?</label
          >
          <input
            type="text"
            v-model="form.employeeCount"
            id="employee-count"
            placeholder="Type your answer..."
          />
        </div>

        <div class="form-group-custom">
          <label>What is your primary focus as an owner?</label>
          <HiloSelect
            :theme="'grey'"
            v-model="form.primaryFocus"
            :options="[]"
            :placeholder="'Select all that apply...'"
            :customStyle="{
              height: '50px',
              width: '100%',
              padding: '10px',
            }"
          />
        </div>

        <div class="form-group-custom">
          <label>Do you actively participate in day-to-day operations?</label>
          <HiloSelect
            :theme="'grey'"
            v-model="form.isActivelyParticipate"
            :options="[]"
            :placeholder="'Choose one...'"
            :customStyle="{
              height: '50px',
              width: '100%',
              padding: '10px',
            }"
          />
        </div>

        <div class="form-group-custom">
          <label for="employee-count"
            >What challenges do you currently face in managing your flight
            school?</label
          >
          <input
            type="text"
            v-model="form.challenges"
            id="employee-count"
            placeholder="Type your answer..."
          />
        </div>
      </div>

      <div class="form-group-custom" v-if="contains(7)">
        <label for="key-metrics"
          >What are your key metrics for tracking flight school
          performance?</label
        >
        <input
          type="text"
          v-model="form.keyMetrics"
          id="key-metrics"
          placeholder="Select all that apply..."
        />
      </div>

      <div class="form-group-custom" v-if="contains(7, 18)">
        <label for="how-do-you-track"
          >How do you currently track student hours and progress?</label
        >
        <input
          type="text"
          v-model="form.howDoYouTrack"
          id="how-do-you-track"
          placeholder="Select all that apply..."
        />
      </div>

      <div v-if="contains(18)" class="gap">
        <div class="form-group-custom">
          <label>What tools or systems do you see to manage your school?</label>
          <HiloSelect
            :theme="'grey'"
            v-model="form.tools"
            :options="[]"
            :placeholder="'Select all that apply...'"
            :customStyle="{
              height: '50px',
              width: '100%',
              padding: '10px',
            }"
          />
        </div>

        <div class="form-group-custom">
          <label>What is your school's primary revenue source?</label>
          <HiloSelect
            :theme="'grey'"
            v-model="form.revenueSource"
            :options="[]"
            :placeholder="'Select all that apply...'"
            :customStyle="{
              height: '50px',
              width: '100%',
              padding: '10px',
            }"
          />
        </div>

        <div class="form-group-custom">
          <label>Do you offer financing or scholarships to students?</label>
          <HiloSelect
            :theme="'grey'"
            v-model="form.isOfferingScholarship"
            :options="[]"
            :placeholder="'Choose one...'"
            :customStyle="{
              height: '50px',
              width: '100%',
              padding: '10px',
            }"
          />
        </div>

        <div class="form-group-custom">
          <label
            >Would you like to connect with lenders to offer more financing
            options to students?</label
          >
          <HiloSelect
            :theme="'grey'"
            v-model="form.wouldLikeToConnect"
            :options="[]"
            :placeholder="'Choose one...'"
            :customStyle="{
              height: '50px',
              width: '100%',
              padding: '10px',
            }"
          />
        </div>

        <div class="form-group-custom">
          <div class="upload-action">
            <span>If so, upload the last three months of bank statements.</span>
            <label for="bank-statements" class="upload-btn">
              Upload
              <input
                type="file"
                id="bank-statements"
                @change="(event) => handleFileUpload(event, 'bankStatements')"
                class="hidden-file-input"
              />
            </label>
          </div>
        </div>

        <div class="form-group-custom">
          <div class="upload-action">
            <span>If so, upload the last two years of tax returns.</span>
            <label for="bank-statements" class="upload-btn">
              Upload
              <input
                type="file"
                id="bank-statements"
                @change="(event) => handleFileUpload(event, 'taxReturns')"
                class="hidden-file-input"
              />
            </label>
          </div>
        </div>

        <div class="form-group-custom">
          <label for="annual-revenue"
            >What is your average annual revenue?</label
          >
          <input
            type="text"
            v-model="form.annualRevenue"
            id="annual-revenue"
            placeholder="Type your answer..."
          />
        </div>

        <div class="form-group-custom">
          <label
            >Do you manage TSA compliance for international students?</label
          >
          <HiloSelect
            :theme="'grey'"
            v-model="form.isManagingTSA"
            :options="[]"
            :placeholder="'Choose one...'"
            :customStyle="{
              height: '50px',
              width: '100%',
              padding: '10px',
            }"
          />
        </div>

        <div class="form-group-custom">
          <label>What are your goals for the next 1-3 years?</label>
          <HiloSelect
            :theme="'grey'"
            v-model="form.goals"
            :options="[]"
            :placeholder="'Select all that apply...'"
            :customStyle="{
              height: '50px',
              width: '100%',
              padding: '10px',
            }"
          />
        </div>

        <div class="form-group-custom">
          <label
            >Would you like assistance with scaling your flight school?</label
          >
          <HiloSelect
            :theme="'grey'"
            v-model="form.wouldLikeAssistance"
            :options="[]"
            :placeholder="'Choose one...'"
            :customStyle="{
              height: '50px',
              width: '100%',
              padding: '10px',
            }"
          />
        </div>

        <div class="form-group-custom">
          <label
            >Would you like to connect with other flight school owners for
            advice and best practices?</label
          >
          <HiloSelect
            :theme="'grey'"
            v-model="form.wouldLikeToConnect"
            :options="[]"
            :placeholder="'Choose one...'"
            :customStyle="{
              height: '50px',
              width: '100%',
              padding: '10px',
            }"
          />
        </div>

        <div class="form-group-custom">
          <label for="airline-partnership"
            >Do you have any airline partnerships?</label
          >
          <input
            type="text"
            v-model="form.haveAirlinePartnership"
            id="airline-partnership"
            placeholder="Type your answer..."
          />
        </div>
      </div>

      <div class="form-group-custom" v-if="contains(7, 18)">
        <label
          >Would you like to receive updates on tools and resources to help you
          manage your flight school?</label
        >
        <HiloSelect
          :theme="'grey'"
          v-model="form.receiveUpdates"
          :options="[]"
          :placeholder="'Choose one...'"
          :customStyle="{
            height: '50px',
            width: '100%',
            padding: '10px',
          }"
        />
      </div>
    </div>

    <div class="buttonContainer">
      <div class="nextButton" @click="handleNext">
        <b class="name">Next</b>
      </div>
      <div class="backButton" @click="$emit('onPrev')">
        <b class="name">Back</b>
      </div>
    </div>

    <!--    V2 -->
    <!--    <PortalPopup-->
    <!--      v-if="showModal"-->
    <!--      overlayColor="rgba(113, 113, 113, 0.3)"-->
    <!--      placement="Centered"-->
    <!--      :onOutsideClick="closeAddFlightSchool"-->
    <!--    >-->
    <!--      <AddFlightSchool @onClose="closeAddFlightSchool" @onSubmit="handleAdd" />-->
    <!--    </PortalPopup>-->
  </div>
</template>
<script>
// import IconSearch from "../icons/IconSearch.vue";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
// import PortalPopup from "../PortalPopup.vue";
// import AddFlightSchool from "../AddFlightSchool.vue";
import FlightSchoolsAPIService from "../../../../../servicehandlers/FlightSchoolsAPIService";
const flightSchoolsAPIService = new FlightSchoolsAPIService();
import SignUpAPIService from "@/servicehandlers/SignUpAPIService";
const signUpAPIService = new SignUpAPIService();

export default {
  // V2
  // components: { IconSearch, HiloSelect, PortalPopup, AddFlightSchool },
  components: { HiloSelect },
  props: {
    userId: {
      type: Number,
      required: true,
    },
    userTypeId: {},
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: {
        isConnectedToAFlightSchool: "",
        flightSchoolId: null,
        pointOfContact: "",
        phone: "",
        street: "",
        city: "",
        state: "",
        zip: "",
        country: "",
      },
      showModal: false,
      flightSchoolsList: [],
      loading: false,
      validations: [
        {
          field: "isConnectedToAFlightSchool",
          desc: "your flight school connection",
        },
      ],
    };
  },
  async mounted() {
    this.loading = true;
    try {
      await this.getFlightSchools();
      await this.getSavedFlightSchoolData();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async getFlightSchools() {
      try {
        this.flightSchoolsList =
          await flightSchoolsAPIService.getAllFlightSchools();
      } catch (error) {}
    },
    async getSavedFlightSchoolData() {
      try {
        const savedData = await signUpAPIService.getUserFlightSchool(
          this.userId,
        );
        if (savedData) {
          this.form = { ...savedData };
        }
      } catch (error) {}
    },
    async handleNext() {
      let isValid = true;
      if (this.form.isConnectedToAFlightSchool) {
        this.validations.push(
          { field: "flightSchoolId", desc: "flight school selection" },
          { field: "pointOfContact", desc: "point of contact" },
          { field: "phone", desc: "phone number" },
          { field: "street", desc: "street address" },
          { field: "city", desc: "city" },
          { field: "state", desc: "state" },
          { field: "zip", desc: "ZIP code" },
          { field: "country", desc: "country" },
        );
      }

      for (const validation of this.validations) {
        const { field, desc } = validation;
        const fieldValue = this.getFieldValue(field);

        if (
          fieldValue === undefined ||
          fieldValue === null ||
          fieldValue === "" ||
          (Array.isArray(fieldValue) && fieldValue.length === 0)
        ) {
          isValid = false;
          alert(`Please enter ${desc}.`);
          break;
        }
      }
      if (!isValid) return;
      await this.saveFlightSchoolData();
    },
    getFieldValue(field) {
      return this.form[field];
    },
    async saveFlightSchoolData() {
      try {
        this.loading = true;
        const flightSchoolData = {
          ...this.form,
        };
        await signUpAPIService.saveUserFlightSchool(
          this.userId,
          flightSchoolData,
        );
        this.$emit("onNext", { flightSchoolConnect: this.form });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    contains(...ids) {
      return ids.includes(this.userTypeId);
    },
    handleFileUpload(event, field) {
      const file = event.target.files[0];
      if (file) this.form[field] = file;
    },
    // V2
    // handleAdd(payload, isAdd = true) {
    //   Object.assign(this.form, payload);
    //   if (isAdd) this.flightSchools.push(payload);
    // },
    // showAddModal() {
    //   this.showModal = true;
    // },
    // closeAddFlightSchool() {
    //   this.showModal = false;
    // },
  },
  watch: {
    "form.flightSchoolId": function (selectedSchool) {
      if (selectedSchool) {
        const school = this.flightSchoolsList.find(
          (s) => s.id === selectedSchool,
        );
        if (school) {
          this.form.pointOfContact = school.contact || "";
          this.form.phone = school.phone || "";
          this.form.street = school.address1 || "";
          this.form.aptOrSuite = school.address2 || "";
          this.form.city = school.city || "";
          this.form.state = school.state || "";
          this.form.zip = school.zip || "";
          this.form.country = "USA";
        }
      }
    },
  },
};
</script>
<style>
.buttonContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.buttonContainer div {
  align-self: stretch;
  border-radius: 10px;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
}

.buttonContainer div:hover {
  opacity: 0.8;
}

.nextButton {
  background-color: #3c78ff;
}

.backButton {
  background-color: #ccc;
}

.gap {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group-custom {
  position: relative;
}
.form-container select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
/* V2
.search-action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
*/
.search-action span {
  font-size: small;
}
.search-action button {
  background-color: var(--vt-c-text-primary);
  border: none;
  border-radius: 5px;
  padding: 0.3rem 1.5rem;
  color: #fff;
  font-size: small;
}
</style>
